import { FC } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import { ChartEmptyState } from '../../AthleteInjuryCharts/charts/_shared/ChartEmptyState';
import { ITeamBodyMapMetric } from '../../../../models/injury';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: ITeamBodyMapMetric | null;
}

export const TeamBodyMapChart: FC<Props> = ({ data }) => {
  if (!data?.data?.length) return <ChartEmptyState />;

  const chartData = [...data.data]
    .sort((a, b) => b.totalDaysLost - a.totalDaysLost)
    .slice(0, 10)
    .map((z) => ({ zone: z.bodyZone, days: z.totalDaysLost, count: z.count }));

  return (
    <ResponsiveContainer width="100%" height={220}>
      <BarChart
        layout="vertical"
        data={chartData}
        margin={{ top: 4, right: 30, left: 4, bottom: 0 }}
      >
        <CartesianGrid {...chartGridProps} vertical horizontal={false} />
        <XAxis type="number" tick={chartAxisTick} />
        <YAxis dataKey="zone" type="category" width={90} tick={chartAxisTick} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(v, _, props) => [
            `${v} gg — ${props.payload.count} inf.`,
            'Giorni persi',
          ]}
        />
        <Bar dataKey="days" fill="var(--c-text-0)" radius={[0, 4, 4, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};
